import { Grid, GridItem, Input, Text } from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

import { FilterSet } from "@nens/ldo/api-v1";

interface FromToFacetProps {
  title: string;
  filter: string;
  filters: FilterSet;
  setFilters: React.Dispatch<React.SetStateAction<FilterSet>>;
}

export function FromToFacet({ title, filter, filters, setFilters }: FromToFacetProps) {
  const fromFilter = `${filter}__ge`;
  const toFilter = `${filter}__le`;

  const fromValue = (filters.checkedValues(fromFilter)[0] as string) ?? undefined;
  const toValue = (filters.checkedValues(toFilter)[0] as string) ?? undefined;

  const [currentFromString, setCurrentFromString] = useState(fromValue);
  const [currentToString, setCurrentToString] = useState(toValue);

  const setFrom = (f: string) => {
    setCurrentFromString(f);
    const fromDate = new Date(f);
    setFilters(
      fromDate.getTime()
        ? filters.set(fromFilter, fromDate.toISOString().slice(0, 10))
        : filters.unset(fromFilter)
    );
  };

  const setTo = (t: string) => {
    setCurrentToString(t);
    const toDate = new Date(t);
    setFilters(
      toDate.getTime()
        ? filters.set(toFilter, toDate.toISOString().slice(0, 10))
        : filters.unset(toFilter)
    );
  };

  return (
    <GridItem px="8px" py="2px" borderBottom="1px" fontWeight="semibold" borderColor={"gray.200"}>
      <Text fontSize="sm" py="6px" fontWeight="semibold">
        {title}
      </Text>
      <Grid templateColumns="1fr 1fr" gap={2}>
        <GridItem>
          <FormattedMessage id="filtertree.from" defaultMessage="From" />:
        </GridItem>
        <GridItem>
          <Input type="date" value={currentFromString} onChange={(e) => setFrom(e.target.value)} />
        </GridItem>
        <GridItem>
          <FormattedMessage id="filtertree.to" defaultMessage="To" />:
        </GridItem>
        <GridItem>
          <Input type="date" value={currentToString} onChange={(e) => setTo(e.target.value)} />
        </GridItem>
      </Grid>
    </GridItem>
  );
}
